import { Descriptions } from "antd";
import moment from "moment";
import { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { getEvent } from "../../../api/events.api";
import Button from "../../../components/Button";
import ErrorResponse from "../../../components/ErrorResponse";
import SimpleHeader from "../../../components/layout/SimpleHeader";
import Loader from "../../../components/Loader";
import useAuth from "../../../hooks/useAuth";
import useAxios from "../../../hooks/useAxios";
import { getCommonCodeLabel } from "../../../lib/store";
import { IGetEvent } from "../../../models/events.model";

interface IMatch {
  eventNo: string;
}

const EducationRead = () => {
  const { t } = useTranslation();
  const { writeAuthYn } = useAuth();
  const match = useRouteMatch<IMatch>();
  const eventNo = Number(match.params.eventNo);
  const history = useHistory();
  const location = useLocation();
  const { data: res, isLoading, error, execute } = useAxios<IGetEvent>();

  useEffect(() => {
    if (eventNo) {
      execute(getEvent('PA', eventNo));
    }
  }, [eventNo]);

  const getCampusInfo = () => {
    if (!res?.data) return '';
    if (res.data.allCampusYn === 'Y') return t('common.text.all');

    let str = '';
    res.data.campuses.forEach(item => {
      str += `${item.campusKorName}, `;
    });
    return str.slice(0, -2);
  }

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <SimpleHeader
        iconFile="icon-event-big.svg"
        parentMenu={t('common.menu.event')}
        currentMenu={t('event.briefing.title4')}
      />

      <div className='comm-table__area rowType'>
        <Descriptions
          bordered
          column={4}
          size="small"
        >
          <Descriptions.Item label={t('event.education.column10')} span={4}>
            {res?.data?.eventName}
          </Descriptions.Item>
          <Descriptions.Item label={t('event.briefing.column1')}>
            {getCommonCodeLabel('BR0017', res?.data?.eventCategory || '', 'ko')}
          </Descriptions.Item>
          <Descriptions.Item label={t('event.briefing.column2')}>
            {res?.data?.eventLocation || '-'}
          </Descriptions.Item>
          <Descriptions.Item label={t('event.education.column3')}>
            {res?.data?.openYn === 'Y' ? t('common.option.yes') : t('common.option.no')}
          </Descriptions.Item>
          <Descriptions.Item label={t('event.briefing.column3')}>
            {res?.data?.allOpenYn === 'Y' ? t('event.briefing.option1') : t('event.briefing.option2')}
          </Descriptions.Item>
          <Descriptions.Item label={t('common.menu.campus')}>
            {getCampusInfo()}
          </Descriptions.Item>
          <Descriptions.Item label={t('event.education.column12')}>
            {moment(res?.data?.eventDate).format('YYYY.MM.DD')} {res?.data?.eventTime}
          </Descriptions.Item>
          <Descriptions.Item label={t('event.education.column7')}>
            {moment(res?.data?.registSrtDate).format('YYYY.MM.DD')}
          </Descriptions.Item>
          <Descriptions.Item label={t('event.education.column8')}>
            {moment(res?.data?.registEndDate).format('YYYY.MM.DD')}
          </Descriptions.Item>
          <Descriptions.Item label={t('event.education.column5')}>
            {res?.data?.quota ? `${t('event.education.text4')}${res?.data?.quota} ${t('event.education.text5')}` : t('event.education.text2')}
          </Descriptions.Item>
          <Descriptions.Item label={t('event.education.column19')}>
            {t('event.education.text4')}{res?.data?.require} {t('event.education.text5')}
          </Descriptions.Item>
          <Descriptions.Item label={t('event.education.column20')} span={2}>
            {t('event.education.text4')}{res?.data?.attend} {t('event.education.text5')}
          </Descriptions.Item>
          <Descriptions.Item label={t('event.education.column15')} span={4}>
            <div dangerouslySetInnerHTML={{ __html: res?.data?.content || '' }} />
          </Descriptions.Item>
          <Descriptions.Item label={t('event.education.column17')} span={4}>
            {
              res?.data?.eventFiles
                ? res.data.eventFiles.map(item => (
                  <a
                    className="download-link mr-2"
                    href={item.fileLocation}
                    download={item.originalName}
                  >
                    {item.originalName}
                  </a>
                ))
                : '-'
            }
          </Descriptions.Item>
        </Descriptions>

        <div className="comm-bx__between">  
          <div className="comm-btn__area">
            <Button
              onClick={() => history.push(`/event/briefing${location.search}`)}
              className="btn-basic gray-line"
              text={t('common.button.list')}
            />
          </div>
          <div className="comm-btn__area right">          
            <Button
              onClick={() => history.push(`/event/briefing/${res?.data?.eventNo}/edit${location.search}`)}
              className="btn-basic pink-line"
              text={t('common.button.edit')}
              writeAuthYn={writeAuthYn}
            />
            <Button
              onClick={() => history.push(`/event/briefing/${res?.data?.eventNo}/register`)}
              className="btn-basic pink-line"
              text={t('event.education.button5')}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default EducationRead;
